import { Injectable } from '@angular/core';
import { LocalStorageKeyEnum } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem<T>(key: LocalStorageKeyEnum, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: LocalStorageKeyEnum): T | null {
    const item = localStorage.getItem(key);
    if (!item) return null;
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      return null;
    }
  }

  removeItem(key: LocalStorageKeyEnum): void {
    localStorage.removeItem(key);
  }
}
